export default __webpack_public_path__ + "static/media/plant.eb74c931.svg";